<template>
  <v-layout class="email-update-container">
    <div v-if="loading">
      <spinner />
    </div>
    <div v-else>
      <v-layout wrap>
        <v-flex xs12>
          <div v-if="$apollo.loading">
            <spinner />
          </div>
          <form v-scroll-to-error class="form-container" @submit.prevent="submitForm">
            <v-flex class="title-screen">
              <span>{{ adminText('workflowsAll.update_automated_e_mail_17c4828', 'Update automated e-mail') }}</span>
            </v-flex>
            <v-flex x4>
              <div class="title-description screen-description" />
            </v-flex>
            <v-flex>
              <create-email-form
                :initial-values="form"
                :event-id="eventId"
                :vs="$v"
                @values="form = $event"
              />
            </v-flex>
            <div class="email-shortcodes hide">
              <email-shortcodes
                :shortcodes="form.sent == 'When added by admin' ? adminShortcodes : shortcodes"
                @shortcode="shortcodeAdded"
              />
            </div>
            <v-flex xs12 class="buttons">
              <main-button flat @click.prevent="goBack"> {{ adminText('workflowsAll.cancel_1507c40', 'CANCEL') }} </main-button>
              <main-button depressed @click="$emit('submit')"> {{ adminText('workflowsAll.update_52c6c18', 'UPDATE') }} </main-button>
            </v-flex>
          </form>
        </v-flex>
      </v-layout>
    </div>
    <div class="email-shortcodes desktop-shortcodes">
      <email-shortcodes
        :shortcodes="form.sent == 'When added by admin' ? adminShortcodes : shortcodes"
        @shortcode="shortcodeAdded"
      />
    </div>
  </v-layout>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { required, email } from 'vuelidate/lib/validators'

import CreateEmailForm from './create-email-form'
import EmailShortcodes from './email-shortcodes'
import Spinner from './../shared/spinner'
import { GET_EMAIL, UPDATE_EMAIL } from '../../graphql/email.graphql'
import { submitGuard } from '../../utils'

export default {
  mixins: [WorkflowDisplay],
  name: 'email-update-container',
  components: {
    CreateEmailForm,
    EmailShortcodes,
    Spinner,
  },
  data() {
    return {
      form: {},
      loading: true,
      eventId: '',
      emailId: '',
      shortcodes: [
        'Attendee workshops',
        'Event name',
        'Attendee name',
        'Event location',
        'Attendee QR code link',
        'Attendee QR code image',
        'Event start',
        'Attendee email',
        'Event end',
        'Country',
        'Function',
        'Event type',
      ],
      adminShortcodes: [
        'Event name',
        'Event location',
        'Event start',
        'Event end',
        'Event type',
        'role',
        'sender',
      ],
    }
  },
  created() {
    this.eventId = this.$route.params.eventId
    this.emailId = this.$route.params.emailId
  },
  methods: {
    shortcodeAdded(shortcode) {
      if (this.form.content) {
        this.form.content = this.form.content
          .slice(0, this.form.content.length - 4)
          .concat(` { ${shortcode} }`)
      } else {
        this.form.content = this.form.content.concat(`{ ${shortcode} }`)
      }
    },
    async updateEmail() {
      const { replyTo, recipients, subject, content, attendees, categories } = this.form
      const identifiers = attendees.length ? attendees : categories.length ? categories : []
      const email = await this.$apollo.mutate({
        mutation: UPDATE_EMAIL,
        variables: {
          emailId: this.emailId,
          email: {
            replyTo: replyTo,
            recipientType: recipients,
            subject: subject,
            content: content,
            identifiers: identifiers.length ? identifiers.map(identifier => identifier.id) : [],
          },
        },
      })
      this.goTo(this.routes.organizer.emails)
    },
    async submitForm() {
      await submitGuard(this, async () => {
        this.updateEmail()
      })
    },
  },
  apollo: {
    getEmail: {
      query: GET_EMAIL,
      variables() {
        return {
          emailId: this.$route.params.emailId,
        }
      },
      result({ data, loading }) {
        if (!loading) {
          const {
            getEmail: {
              emailRecipient: { id, identifiers, recipientType },
              ...emailData
            },
          } = data
          this.form = emailData
          this.form.recipients = recipientType
          if (recipientType == 'Specific categories') {
            this.form.categories = identifiers
          }
          this.loading = false
        }
      },
    },
  },
  validations() {
    return {
      form: {
        replyTo: { required, email },
        recipients: { required },
        subject: { required },
        content: { required },
      },
    }
  },
}
</script>

<style scoped>
.screen-description {
  max-width: 680px;
  margin-bottom: 28px;
}
.form-container {
  margin-right: 30px;
  max-width: 40.75rem;
}
.desktop-shortcodes {
  margin: 355px -60px 0 0;
  min-width: 200px !important;
  display: block !important;
  margin-left: 24px;
}
.email-shortcodes {
  display: none;
}
@media screen and (max-width: 1279px) {
  .desktop-shortcodes {
    display: none !important;
  }
  .email-shortcodes {
    margin: 16px 0;
    margin-bottom: 32px;
    display: block;
  }
}
@media (max-width: 800px) {
  .email-update-container {
    display: flex;
    flex-direction: column;
  }
  .form-container {
    margin-right: 0;
  }
}
.buttons {
  display: flex;
  justify-content: space-between;
}
@media screen and (max-width: 445px) {
  .buttons {
    flex-direction: column;
  }
}
.title-screen {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
</style>
